var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D32130CA-4DF7-4C3C-9A9B-A0CF3AE245B2@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KP-Consumption_Clone-Confirmation",
    transform: "translate(-505.000000, -345.000000)",
    fill: "#177b57",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-51",
    transform: "translate(480.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_layers_3994188_000000",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3337489,20.0000147 L5.33382221,20.0000147 C4.59707775,20.0000147 4.00010266,19.4030396 4.00010266,18.6662951 L4.00010266,6.66636845 L2.67098832,6.66636845 L2.67098832,21.3393661 L17.3337489,21.3393661 L17.3337489,20.0000147 Z M20.0000147,20.0000147 L20.0000147,22.6662805 C20.0000147,23.4030249 19.4030396,24 18.6662951,24 L1.33371954,24 C0.596975086,24 0,23.4030249 0,22.6662805 L0,5.33370488 C0,4.59696042 0.596975086,3.99998533 1.33371954,3.99998533 L3.99998533,3.99998533 L3.99998533,1.33371954 C3.99998533,0.596975086 4.59696042,0 5.33370488,0 L22.6662805,0 C23.4030249,0 24,0.596975086 24,1.33371954 L24,18.6662951 C24,19.4030396 23.4030249,20.0000147 22.6662805,20.0000147 L20.0000147,20.0000147 Z M6.66633912,2.66743909 L6.66633912,17.3336902 L21.3325902,17.3336902 L21.3325902,2.66743909 L6.66633912,2.66743909 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.4fae097469b92679f0806bc678d1434a.svg";
export { ForwardRef as ReactComponent };